import Query from '../../../../../components/Report';

export const query = ({ prompt_uids = [], platforms = '', link_type = '' }) =>
    new Query('ai-tracking-all-links', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        platforms: platforms?.length ? setPlatforms(platforms) : '',
        link_type: link_type ? `and ${link_type}` : '',
    });

function setKeywordUids(ids) {
    return `prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}

function setPlatforms(platforms) {
    return `and platform in (${platforms.map((item) => `'${item}'`)})`;
}
